const API_URL = process.env.REACT_APP_API_URL || "https://t5jalxqqsb.execute-api.eu-west-2.amazonaws.com";

export default async function Discover(lat, lng, category, radius) {
  const response = await fetch(`${API_URL}/discover`, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ lat, lng, category, radius }),
  });
  const payload = await response.json();
  if (!response.ok) throw new Error(payload.error || "Could not find nearby places");
  const data = payload.data;
  return Array.isArray(data) ? data : data?.results || [];
}
